import { supabase } from '@/lib/supabase'

export type RoleCommunityPolicy = {
  role: string
  community_enabled: boolean
}

export type PlanCommunityPolicy = {
  plan_id: string
  community_enabled: boolean
}

export async function fetchRoleCommunityPolicies(): Promise<RoleCommunityPolicy[]> {
  const { data, error } = await supabase
    .from('role_community_policies')
    .select('role,community_enabled')
    .order('role', { ascending: true })

  if (error) throw error
  return (data || []) as RoleCommunityPolicy[]
}

export async function upsertRoleCommunityPolicy(role: string, enabled: boolean): Promise<void> {
  const { error } = await supabase
    .from('role_community_policies')
    .upsert({ role, community_enabled: enabled }, { onConflict: 'role' })

  if (error) throw error
}

export async function fetchPlanCommunityPolicies(): Promise<PlanCommunityPolicy[]> {
  const { data, error } = await supabase
    .from('plan_community_policies')
    .select('plan_id,community_enabled')
    .order('plan_id', { ascending: true })

  if (error) throw error
  return (data || []) as PlanCommunityPolicy[]
}

export async function upsertPlanCommunityPolicy(planId: string, enabled: boolean): Promise<void> {
  const { error } = await supabase
    .from('plan_community_policies')
    .upsert({ plan_id: planId, community_enabled: enabled }, { onConflict: 'plan_id' })

  if (error) throw error
}

